module.exports = __webpack_public_path__ + "img/web-P4-1-4.e19f6e5a.svg";